import { ValidationError } from '@finnest/core/result';
import { onboardingPhaseIdFromNumber } from '@finnest/power-admin-contracts';
import type { AdminDataScope, CustomerId } from '@finnest/power-admin-contracts';
import { Result } from 'better-result';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InvalidPhaseDetailPage } from './-invalid-phase-detail-page.tsx';
import { ValidPhaseDetailPage } from './-phase-detail-page.tsx';

export const Route = createFileRoute('/onboarding/p{$phaseId}')({
  component: PhaseDetailPage,
});

export const phaseIdFromParam = (
  phaseSuffix: string,
): ReturnType<typeof onboardingPhaseIdFromNumber> => onboardingPhaseIdFromNumber(phaseSuffix);

export const onboardingCustomerIdFromScope = (
  scope: AdminDataScope,
): Result<CustomerId, ValidationError> => {
  const { customerId } = scope;
  if (customerId === undefined) {
    return Result.err(
      new ValidationError({ field: 'customerId', message: 'Selecione um cliente da plataforma.' }),
    );
  }
  return Result.ok(customerId);
};

const PhaseSuffixParams = z.object({ phaseSuffix: z.string().min(1) });

function PhaseDetailPage(): JSX.Element {
  const rawParams = Route.useParams();
  const raw: z.input<typeof PhaseSuffixParams> = { phaseSuffix: rawParams.phaseId };
  const parsed = PhaseSuffixParams.safeParse(raw);
  if (!parsed.success) {
    return <InvalidPhaseDetailPage />;
  }
  const lookedUp = phaseIdFromParam(parsed.data.phaseSuffix);
  const pages = {
    unrecognised: <InvalidPhaseDetailPage />,
    phase:
      lookedUp.kind === 'phase' ? (
        <ValidPhaseDetailPage id={lookedUp.phaseId} />
      ) : (
        <InvalidPhaseDetailPage />
      ),
  } satisfies Record<typeof lookedUp.kind, JSX.Element>;
  return pages[lookedUp.kind];
}
